
<a :href="link" class="d-flex justify-content-center flex-column px-3 py-3">
  <div class="d-flex align-items-center imgBox">
    <img :src="imagePath" alt="Flower Photo" class="" :style="styleObject" />
    <app-title-text :text="title" class="ml-3 gray"></app-title-text>
  </div>
  <app-normal-text2 :text="description" class="" :style="styleObject"></app-normal-text2>
</a>
